// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  z-index: 10000;
  /* background-color: #232323; */
  width: 100vw;
  height: 100px;
  /* padding-bottom: 35px; */
}

@media only screen and (max-width: 800px) {
  .header {
    height: 150px;
  }
  .pages {
    float: none;
    position: absolute;
    padding-top: 80px;
    margin-left: -30px;
    text-align: center;
    /* left: 120px; */
    /* padding-left: 20px; */
    /* margin-left: 10px; */
    /* float: left; */
  }
  .page-list {
    /* margin: 20px; */
    /* padding: 60px; */
    position: relative;
    float: none;
    /* padding-left: 20px; */
    /* margin-left: 10px; */
  }
  .title-logo {
    margin-top: 10px;
  }
  .title-left {
    /* float: left; */
    position: absolute;
    color: white;
    margin-top: 25px;
    margin-left: 0px;
    padding-top: 10px;
    padding-left: 100px;
    /* padding: 20px; */
  }
}

.title-logo {
  float: left;
  width: 95px;
  height: 95px;
  margin-left: 10px;
}

.title-left {
  text-shadow:
    0 0 3px #5a7887,
    0 0 5px #63a8be;
  float: left;
  color: white;
  margin-top: 25px;
  margin-left: 10px;
  font-size: 30px;
  /* font-style: bold; */
}

.pages {
  text-shadow:
    0 0 3px #5a7887,
    0 0 5px #63a8be;
  margin-top: 25px;
  float: right;
  color: white;
  text-align: center;
  font-size: 30px;
}

.page-list {
  text-align: center;
  /* display: inline-block; */
  list-style: none;
  margin: 0 auto;
  display: flex;
  /* padding: 20px; */
  margin-right: 20px;
  justify-content: space-evenly;
}

.page-list > li {
  margin-right: 20px;
}

.page-list li:hover {
  /* background-color: black; */
  border-radius: 350px;
}
/* .navbar-collapse {
  -ms-flex-preferred-size: 100%;
  flex-basis: 100%;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.navbar-expand .navbar-collapse {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
  -ms-flex-preferred-size: auto;
  flex-basis: auto;
}

@media (min-width: 768px) {
  .navbar-toggleable-sm .navbar-collapse {
    display: -webkit-box !important;
    display: -webkit-flex !important;
    display: -ms-flexbox !important;
    display: flex !important;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .menu .navbar-toggleable-sm .navbar-collapse {
    display: -webkit-flex !important;
  }
} */
`, "",{"version":3,"sources":["webpack://./src/nav/NavBar.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,+BAA+B;EAC/B,YAAY;EACZ,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;IACxB,uBAAuB;EACzB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE;;mBAEiB;EACjB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE;;mBAEiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiCG","sourcesContent":[".header {\n  z-index: 10000;\n  /* background-color: #232323; */\n  width: 100vw;\n  height: 100px;\n  /* padding-bottom: 35px; */\n}\n\n@media only screen and (max-width: 800px) {\n  .header {\n    height: 150px;\n  }\n  .pages {\n    float: none;\n    position: absolute;\n    padding-top: 80px;\n    margin-left: -30px;\n    text-align: center;\n    /* left: 120px; */\n    /* padding-left: 20px; */\n    /* margin-left: 10px; */\n    /* float: left; */\n  }\n  .page-list {\n    /* margin: 20px; */\n    /* padding: 60px; */\n    position: relative;\n    float: none;\n    /* padding-left: 20px; */\n    /* margin-left: 10px; */\n  }\n  .title-logo {\n    margin-top: 10px;\n  }\n  .title-left {\n    /* float: left; */\n    position: absolute;\n    color: white;\n    margin-top: 25px;\n    margin-left: 0px;\n    padding-top: 10px;\n    padding-left: 100px;\n    /* padding: 20px; */\n  }\n}\n\n.title-logo {\n  float: left;\n  width: 95px;\n  height: 95px;\n  margin-left: 10px;\n}\n\n.title-left {\n  text-shadow:\n    0 0 3px #5a7887,\n    0 0 5px #63a8be;\n  float: left;\n  color: white;\n  margin-top: 25px;\n  margin-left: 10px;\n  font-size: 30px;\n  /* font-style: bold; */\n}\n\n.pages {\n  text-shadow:\n    0 0 3px #5a7887,\n    0 0 5px #63a8be;\n  margin-top: 25px;\n  float: right;\n  color: white;\n  text-align: center;\n  font-size: 30px;\n}\n\n.page-list {\n  text-align: center;\n  /* display: inline-block; */\n  list-style: none;\n  margin: 0 auto;\n  display: flex;\n  /* padding: 20px; */\n  margin-right: 20px;\n  justify-content: space-evenly;\n}\n\n.page-list > li {\n  margin-right: 20px;\n}\n\n.page-list li:hover {\n  /* background-color: black; */\n  border-radius: 350px;\n}\n/* .navbar-collapse {\n  -ms-flex-preferred-size: 100%;\n  flex-basis: 100%;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.navbar-expand .navbar-collapse {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n}\n\n@media (min-width: 768px) {\n  .navbar-toggleable-sm .navbar-collapse {\n    display: -webkit-box !important;\n    display: -webkit-flex !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    width: 100%;\n  }\n}\n\n@media (min-width: 992px) {\n  .menu .navbar-toggleable-sm .navbar-collapse {\n    display: -webkit-flex !important;\n  }\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
